export const DISTRIBUTOR_BRANDS_SET = 'DISTRIBUTOR_BRANDS_SET'
export const DISTRIBUTOR_BRANDS_UPDATE = 'DISTRIBUTOR_BRANDS_UPDATE'
export const DISTRIBUTOR_BRANDS_FETCHING = 'DISTRIBUTOR_BRANDS_FETCHING'
export const DISTRIBUTOR_BRANDS_UPDATING = 'DISTRIBUTOR_BRANDS_UPDATING'
export const DISTRIBUTOR_BRANDS_BINDINGS_FETCHING =
  'DISTRIBUTOR_BRANDS_BINDINGS_FETCHING'
